module.exports = __webpack_public_path__ + "img/refresh.27afd85b.svg";